// extracted by mini-css-extract-plugin
export default {"btn":"ScrollToTop_btn__ERzlk","arrow":"ScrollToTop_arrow__lsO1T"};